import { render, staticRenderFns } from "./StrQuillEditor.vue?vue&type=template&id=2f5a80d8&"
import script from "./StrQuillEditor.vue?vue&type=script&lang=js&"
export * from "./StrQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./StrQuillEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports